import { useTranslation } from 'react-i18next';

const liquidityImg = 'http://geel.fp.08wx.cn/images/00f113836f75af9345dadb754bf6a7a0.jpg';

type LocaleKey = 'zh-CN' | 'en' | 'zh-TW';

const COPY = {
  'zh-CN': {
    badge: 'Liquidity Mining',
    title1: 'AMM 流动性挖矿',
    title2: '深度流动性，持续收益',
    desc: '基于 Uniswap V3 集中流动性模型，资金效率大幅提升。LP 提供流动性自动获取交易手续费分成，同时享受平台 TOKEN 奖励，实现双重收益叠加。',
    cardTitle: '流动性挖矿',
    cardMeta: 'AMM · 集中流动性 · 最高 120% APY',
    poolExampleTitle: '当前热门流动性池（示例）',
    riskSuffix: '风险',
    bridgeBadge: 'Bridge & Governance',
    bridgeTitle: '跨链桥 + DAO 治理',
    bridgeDesc: '打通多链生态壁垒，赋予社区真正的协议治理权',
    aggregatorTitle: '收益聚合器',
    ammFeatures: [
      { icon: 'ri-water-flash-line', title: 'Uniswap V3 兼容 AMM', desc: '集中流动性做市，资金效率比 V2 提升 4000%，手续费分层' },
      { icon: 'ri-line-chart-line', title: '动态手续费策略', desc: '根据波动率自动调整手续费档位（0.01% / 0.05% / 0.3% / 1%）' },
      { icon: 'ri-safe-line', title: '闪电贷集成', desc: '支持原子性闪电贷，无需抵押借款用于套利/清算，增加平台收入' },
      { icon: 'ri-bar-chart-2-line', title: '价格预言机', desc: '内置 TWAP 时间加权价格，防止操纵，为 DeFi 生态提供可靠报价' },
    ],
    yieldFarmItems: [
      { pool: 'ETH/USDC', apy: '24.3%', tvl: '$12.4M', vol24h: '$8.2M', risk: '低' },
      { pool: 'BTC/ETH', apy: '18.7%', tvl: '$9.8M', vol24h: '$6.1M', risk: '低' },
      { pool: 'TOKEN/USDT', apy: '86.2%', tvl: '$2.1M', vol24h: '$1.4M', risk: '中' },
      { pool: 'ETH/TOKEN', apy: '120%', tvl: '$0.8M', vol24h: '$0.5M', risk: '高' },
    ],
    riskColors: { '低': '#FF2D78', '中': '#FF8C42', '高': '#ef4444' },
    bridgeFeatures: [
      { icon: 'ri-git-merge-line', title: 'LayerZero 全链通信', desc: '支持 40+ 链间跨链转账，5-30 秒完成，手续费极低' },
      { icon: 'ri-refresh-line', title: '跨链原子兑换', desc: '跨链资产兑换无中间方，完全去信任，防止双花攻击' },
      { icon: 'ri-shield-check-line', title: '多重验证安全', desc: '守护者网络 + 中继器 + 执行层三重验证，资金损失险赔付' },
      { icon: 'ri-government-line', title: 'DAO 治理投票', desc: '代币持有者发起提案、投票、执行，Snapshot 链下 + 链上双轨' },
    ],
    aggregatorFeatures: [
      { icon: 'ri-robot-line', title: '智能策略路由', desc: '实时扫描 50+ DeFi 协议，自动将资金分配至当前收益最高的组合' },
      { icon: 'ri-refresh-line', title: '自动复投与再平衡', desc: '收益自动复投，定期再平衡仓位，减少手动操作，收益最大化' },
      { icon: 'ri-shield-check-line', title: '风险评分系统', desc: '每个策略附带风险评分（合约安全/审计/TVL/历史稳定性），透明决策' },
    ],
  },
  en: {
    badge: 'Liquidity Mining',
    title1: 'AMM Liquidity Mining',
    title2: 'Deep Liquidity, Sustainable Yield',
    desc: 'Built on the Uniswap V3 concentrated-liquidity model to significantly improve capital efficiency. LPs earn trading fees and platform token incentives for stacked yield.',
    cardTitle: 'Liquidity Mining',
    cardMeta: 'AMM · Concentrated Liquidity · Up to 120% APY',
    poolExampleTitle: 'Top Liquidity Pools (Sample)',
    riskSuffix: 'Risk',
    bridgeBadge: 'Bridge & Governance',
    bridgeTitle: 'Cross-Chain Bridge + DAO Governance',
    bridgeDesc: 'Breaks multi-chain silos and gives the community real protocol governance power.',
    aggregatorTitle: 'Yield Aggregator',
    ammFeatures: [
      { icon: 'ri-water-flash-line', title: 'Uniswap V3-Compatible AMM', desc: 'Concentrated market-making with up to 4000% higher capital efficiency versus V2, with tiered fees.' },
      { icon: 'ri-line-chart-line', title: 'Dynamic Fee Strategy', desc: 'Auto-adjusts fee tiers (0.01% / 0.05% / 0.3% / 1%) based on market volatility.' },
      { icon: 'ri-safe-line', title: 'Flash Loan Integration', desc: 'Supports atomic flash loans for arbitrage and liquidation without collateral to increase platform revenue.' },
      { icon: 'ri-bar-chart-2-line', title: 'Price Oracle', desc: 'Built-in TWAP pricing to resist manipulation and provide reliable quotes for the DeFi ecosystem.' },
    ],
    yieldFarmItems: [
      { pool: 'ETH/USDC', apy: '24.3%', tvl: '$12.4M', vol24h: '$8.2M', risk: 'Low' },
      { pool: 'BTC/ETH', apy: '18.7%', tvl: '$9.8M', vol24h: '$6.1M', risk: 'Low' },
      { pool: 'TOKEN/USDT', apy: '86.2%', tvl: '$2.1M', vol24h: '$1.4M', risk: 'Medium' },
      { pool: 'ETH/TOKEN', apy: '120%', tvl: '$0.8M', vol24h: '$0.5M', risk: 'High' },
    ],
    riskColors: { Low: '#FF2D78', Medium: '#FF8C42', High: '#ef4444' },
    bridgeFeatures: [
      { icon: 'ri-git-merge-line', title: 'LayerZero Omnichain Messaging', desc: 'Supports transfers across 40+ chains with 5-30s settlement and low fees.' },
      { icon: 'ri-refresh-line', title: 'Atomic Cross-Chain Swaps', desc: 'Trustless cross-chain asset swaps without intermediaries, preventing double-spend risks.' },
      { icon: 'ri-shield-check-line', title: 'Multi-Layer Security Validation', desc: 'Guardian network, relayer, and execution-layer checks with loss-protection coverage.' },
      { icon: 'ri-government-line', title: 'DAO Governance Voting', desc: 'Token holders can propose, vote, and execute using hybrid off-chain Snapshot and on-chain governance.' },
    ],
    aggregatorFeatures: [
      { icon: 'ri-robot-line', title: 'Intelligent Strategy Routing', desc: 'Scans 50+ DeFi protocols in real time and allocates to the highest-yield strategy mix.' },
      { icon: 'ri-refresh-line', title: 'Auto-Compounding & Rebalancing', desc: 'Automatically compounds rewards and rebalances positions to reduce manual operations.' },
      { icon: 'ri-shield-check-line', title: 'Risk Scoring System', desc: 'Each strategy includes transparent risk scores across contract security, audits, TVL, and stability history.' },
    ],
  },
  'zh-TW': {
    badge: 'Liquidity Mining',
    title1: 'AMM 流動性挖礦',
    title2: '深度流動性，持續收益',
    desc: '基於 Uniswap V3 集中流動性模型，資金效率大幅提升。LP 提供流動性可自動獲取交易手續費分成，同時享受平台 TOKEN 獎勵，實現雙重收益疊加。',
    cardTitle: '流動性挖礦',
    cardMeta: 'AMM · 集中流動性 · 最高 120% APY',
    poolExampleTitle: '目前熱門流動性池（示例）',
    riskSuffix: '風險',
    bridgeBadge: 'Bridge & Governance',
    bridgeTitle: '跨鏈橋 + DAO 治理',
    bridgeDesc: '打通多鏈生態壁壘，賦予社群真正的協議治理權',
    aggregatorTitle: '收益聚合器',
    ammFeatures: [
      { icon: 'ri-water-flash-line', title: 'Uniswap V3 相容 AMM', desc: '集中流動性做市，資金效率較 V2 提升 4000%，手續費分層' },
      { icon: 'ri-line-chart-line', title: '動態手續費策略', desc: '依波動率自動調整手續費檔位（0.01% / 0.05% / 0.3% / 1%）' },
      { icon: 'ri-safe-line', title: '閃電貸整合', desc: '支援原子性閃電貸，無需抵押借款用於套利/清算，增加平台收入' },
      { icon: 'ri-bar-chart-2-line', title: '價格預言機', desc: '內建 TWAP 時間加權價格，防止操縱，為 DeFi 生態提供可靠報價' },
    ],
    yieldFarmItems: [
      { pool: 'ETH/USDC', apy: '24.3%', tvl: '$12.4M', vol24h: '$8.2M', risk: '低' },
      { pool: 'BTC/ETH', apy: '18.7%', tvl: '$9.8M', vol24h: '$6.1M', risk: '低' },
      { pool: 'TOKEN/USDT', apy: '86.2%', tvl: '$2.1M', vol24h: '$1.4M', risk: '中' },
      { pool: 'ETH/TOKEN', apy: '120%', tvl: '$0.8M', vol24h: '$0.5M', risk: '高' },
    ],
    riskColors: { '低': '#FF2D78', '中': '#FF8C42', '高': '#ef4444' },
    bridgeFeatures: [
      { icon: 'ri-git-merge-line', title: 'LayerZero 全鏈通訊', desc: '支援 40+ 鏈間跨鏈轉帳，5-30 秒完成，手續費極低' },
      { icon: 'ri-refresh-line', title: '跨鏈原子兌換', desc: '跨鏈資產兌換無中間方，完全去信任，防止雙花攻擊' },
      { icon: 'ri-shield-check-line', title: '多重驗證安全', desc: '守護者網路 + 中繼器 + 執行層三重驗證，資金損失險賠付' },
      { icon: 'ri-government-line', title: 'DAO 治理投票', desc: '代幣持有者可發起提案、投票、執行，Snapshot 鏈下 + 鏈上雙軌' },
    ],
    aggregatorFeatures: [
      { icon: 'ri-robot-line', title: '智慧策略路由', desc: '即時掃描 50+ DeFi 協議，自動將資金分配至目前收益最高的組合' },
      { icon: 'ri-refresh-line', title: '自動複投與再平衡', desc: '收益自動複投，定期再平衡倉位，減少手動操作，收益最大化' },
      { icon: 'ri-shield-check-line', title: '風險評分系統', desc: '每個策略附帶風險評分（合約安全/審計/TVL/歷史穩定性），透明決策' },
    ],
  },
};

export default function DefiLiquiditySection() {
  const { i18n } = useTranslation();
  const lang = (i18n.resolvedLanguage || i18n.language || 'zh-CN').toLowerCase();
  const locale: LocaleKey = lang.startsWith('zh-tw') || lang.startsWith('zh-hk') ? 'zh-TW' : lang.startsWith('en') ? 'en' : 'zh-CN';
  const copy = COPY[locale];

  return (
    <section id="liquidity" className="bg-light-section py-24">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="flex flex-col lg:flex-row gap-14 xl:gap-20 mb-20">
          <div className="lg:w-[420px] xl:w-[500px] flex-shrink-0">
            <div className="relative rounded-2xl overflow-hidden border border-primary/15 sticky top-24">
              <div className="w-full h-[300px]">
                <img src={liquidityImg} alt="Liquidity Mining" className="w-full h-full object-cover object-top" />
                <div className="absolute inset-0 bg-gradient-to-t from-white/60 via-transparent to-transparent" />
              </div>
              <div className="absolute top-4 left-4 bg-white/95 border border-primary/20 rounded-xl px-4 py-3 backdrop-blur-sm">
                <div className="flex items-center gap-2 mb-1">
                  <i className="ri-water-flash-line text-primary text-sm" />
                  <span className="text-gray-800 text-xs font-medium">{copy.cardTitle}</span>
                </div>
                <div className="text-gray-400 text-xs">{copy.cardMeta}</div>
              </div>
              <div className="p-4 bg-white">
                <div className="text-xs text-gray-400 mb-3">{copy.poolExampleTitle}</div>
                <div className="space-y-2">
                  {copy.yieldFarmItems.map((p, i) => (
                    <div key={i} className="flex items-center justify-between bg-light-alt rounded-lg px-3 py-2">
                      <span className="text-gray-800 text-xs font-medium">{p.pool}</span>
                      <span className="text-primary text-xs font-semibold">{p.apy} APY</span>
                      <span className="text-xs px-1.5 py-0.5 rounded" style={{ background: `${copy.riskColors[p.risk as keyof typeof copy.riskColors]}12`, color: copy.riskColors[p.risk as keyof typeof copy.riskColors] }}>{p.risk} {copy.riskSuffix}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="flex-1 min-w-0">
            <div className="inline-flex items-center gap-2 mb-6 px-3 py-1.5 bg-primary/10 border border-primary/20 rounded-full">
              <i className="ri-water-flash-line text-primary text-xs" />
              <span className="text-primary text-xs font-medium uppercase tracking-widest">{copy.badge}</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-gray-900 mb-4 leading-tight">
              {copy.title1}
              <br />
              <span className="text-primary">{copy.title2}</span>
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-8">{copy.desc}</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
              {copy.ammFeatures.map((f, i) => (
                <div key={i} className="bg-white border border-primary/10 rounded-xl p-4 hover:border-primary/25 transition-all duration-200">
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary/10 flex-shrink-0 mt-0.5">
                      <i className={`${f.icon} text-sm text-primary`} />
                    </div>
                    <div>
                      <h4 className="text-gray-800 text-sm font-medium mb-1">{f.title}</h4>
                      <p className="text-gray-500 text-xs leading-relaxed">{f.desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div id="bridge">
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-2 mb-4 px-3 py-1.5 bg-accent/10 border border-accent/20 rounded-full">
              <i className="ri-git-merge-line text-accent text-xs" />
              <span className="text-accent text-xs font-medium uppercase tracking-widest">{copy.bridgeBadge}</span>
            </div>
            <h3 className="text-2xl md:text-3xl font-heading font-bold text-gray-900 mb-3">{copy.bridgeTitle}</h3>
            <p className="text-gray-500 text-sm max-w-xl mx-auto">{copy.bridgeDesc}</p>
          </div>
          <div id="governance" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {copy.bridgeFeatures.map((f, i) => (
              <div key={i} className="bg-white border border-primary/10 rounded-xl p-5 hover:border-accent/25 transition-all duration-200">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent/10 mb-4">
                  <i className={`${f.icon} text-accent text-lg`} />
                </div>
                <h4 className="text-gray-800 font-medium text-sm mb-2">{f.title}</h4>
                <p className="text-gray-500 text-xs leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div id="aggregator" className="mt-16">
          <div className="bg-white border border-primary/10 rounded-2xl p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-bar-chart-grouped-line text-primary text-lg" />
              </div>
              <h3 className="text-gray-900 font-heading font-bold text-xl">{copy.aggregatorTitle}</h3>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              {copy.aggregatorFeatures.map((f, i) => (
                <div key={i} className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary/10 flex-shrink-0">
                    <i className={`${f.icon} text-primary text-lg`} />
                  </div>
                  <div>
                    <h4 className="text-gray-800 font-medium text-sm mb-2">{f.title}</h4>
                    <p className="text-gray-500 text-xs leading-relaxed">{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
